<template>
  <svg
    v-if="disabled"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1203_1170)">
      <path
        d="M7 13.125C5.37555 13.125 3.81763 12.4797 2.66897 11.331C1.52031 10.1824 0.875 8.62445 0.875 7C0.875 5.37555 1.52031 3.81763 2.66897 2.66897C3.81763 1.52031 5.37555 0.875 7 0.875C8.62445 0.875 10.1824 1.52031 11.331 2.66897C12.4797 3.81763 13.125 5.37555 13.125 7C13.125 8.62445 12.4797 10.1824 11.331 11.331C10.1824 12.4797 8.62445 13.125 7 13.125ZM7 14C8.85652 14 10.637 13.2625 11.9497 11.9497C13.2625 10.637 14 8.85652 14 7C14 5.14348 13.2625 3.36301 11.9497 2.05025C10.637 0.737498 8.85652 0 7 0C5.14348 0 3.36301 0.737498 2.05025 2.05025C0.737498 3.36301 0 5.14348 0 7C0 8.85652 0.737498 10.637 2.05025 11.9497C3.36301 13.2625 5.14348 14 7 14Z"
        fill="#A4AAAE"
      />
      <path
        d="M7.81371 5.7645L5.80996 6.01562L5.73821 6.34812L6.13196 6.42075C6.38921 6.482 6.43996 6.57475 6.38396 6.83112L5.73821 9.86562C5.56846 10.6505 5.83008 11.0197 6.44521 11.0197C6.92208 11.0197 7.47596 10.7992 7.72708 10.4965L7.80408 10.1325C7.62908 10.2865 7.37358 10.3477 7.20383 10.3477C6.96321 10.3477 6.87571 10.1789 6.93783 9.88137L7.81371 5.7645ZM7.87496 3.9375C7.87496 4.16956 7.78277 4.39212 7.61868 4.55622C7.45458 4.72031 7.23202 4.8125 6.99996 4.8125C6.76789 4.8125 6.54533 4.72031 6.38124 4.55622C6.21715 4.39212 6.12496 4.16956 6.12496 3.9375C6.12496 3.70544 6.21715 3.48288 6.38124 3.31878C6.54533 3.15469 6.76789 3.0625 6.99996 3.0625C7.23202 3.0625 7.45458 3.15469 7.61868 3.31878C7.78277 3.48288 7.87496 3.70544 7.87496 3.9375Z"
        fill="#A4AAAE"
      />
    </g>
    <defs>
      <clipPath id="clip0_1203_1170">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>

  <svg
    v-else
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_41_53)">
      <path
        d="M8 15C6.14348 15 4.36301 14.2625 3.05025 12.9497C1.7375 11.637 1 9.85652 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8C15 9.85652 14.2625 11.637 12.9497 12.9497C11.637 14.2625 9.85652 15 8 15ZM8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16Z"
        fill="#CB3243"
      />
      <path
        d="M7.00201 11C7.00201 10.8687 7.02788 10.7386 7.07813 10.6173C7.12839 10.496 7.20205 10.3857 7.29491 10.2929C7.38777 10.2 7.49801 10.1264 7.61933 10.0761C7.74066 10.0259 7.87069 9.99999 8.00201 9.99999C8.13334 9.99999 8.26337 10.0259 8.3847 10.0761C8.50602 10.1264 8.61626 10.2 8.70912 10.2929C8.80198 10.3857 8.87564 10.496 8.92589 10.6173C8.97615 10.7386 9.00201 10.8687 9.00201 11C9.00201 11.2652 8.89666 11.5196 8.70912 11.7071C8.52158 11.8946 8.26723 12 8.00201 12C7.7368 12 7.48244 11.8946 7.29491 11.7071C7.10737 11.5196 7.00201 11.2652 7.00201 11ZM7.10001 4.99499C7.0867 4.86884 7.10005 4.74129 7.13921 4.62062C7.17838 4.49996 7.24247 4.38888 7.32733 4.29458C7.4122 4.20029 7.51594 4.12489 7.63183 4.07328C7.74771 4.02167 7.87315 3.995 8.00001 3.995C8.12687 3.995 8.25232 4.02167 8.3682 4.07328C8.48409 4.12489 8.58783 4.20029 8.6727 4.29458C8.75756 4.38888 8.82165 4.49996 8.86081 4.62062C8.89998 4.74129 8.91333 4.86884 8.90001 4.99499L8.55001 8.50199C8.53825 8.63977 8.47522 8.76811 8.37337 8.86163C8.27152 8.95515 8.13829 9.00705 8.00001 9.00705C7.86174 9.00705 7.7285 8.95515 7.62666 8.86163C7.52481 8.76811 7.46177 8.63977 7.45001 8.50199L7.10001 4.99499Z"
        fill="#CB3243"
      />
    </g>
    <defs>
      <clipPath id="clip0_41_53">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
<script>
export default {
  props: ["disabled"],
};
</script>
